import { useEffect, useRef, useState } from "react";
import { Buffer } from "buffer";
import { Swiper, SwiperSlide } from "swiper/react";
import { useNavigate, NavLink } from "react-router-dom";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./home.css";
import ClipLoader from "react-spinners/ClipLoader";
import { getProductList } from "../../API/mangoholidayAPI";
import emailjs from "@emailjs/browser";
import {
  FaChevronUp,
  FaChevronDown,
  FaSearch,
  FaMapMarkerAlt,
} from "react-icons/fa";

if (typeof window !== "undefined" && !window.Buffer) {
  window.Buffer = Buffer;
}

// const bannerBaseURL = "https://mangoholidays.in/BannerImg";

// FAQs Data (Common, Booking, After Booking, While Travelling)
const commonFaqs = [
  {
    faqId: 1,
    question: "How many members are there in a group?",
    answer:
      "Number of Guests travelling in a group tour varies as per the destination. Average size of the group for an international tour is 40 to 48 people.",
  },
  {
    faqId: 2,
    question: "Can I do only a part of the Group tour?",
    answer:
      "Yes that is possible. Our sales staff will give you information regarding the same.",
  },
  {
    faqId: 3,
    question:
      "Is it possible for me to extend my stay at any of the destinations that are part of the itinerary?",
    answer:
      "Yes you can extend their stay by informing the sales staff at the time of booking or at least one month prior to the tour / before the journey tickets are issued. Additional charges for the changes will be applicable and these have to be borne by you over and above the tour price. Once the tour departs, no changes can be made.",
  },
  {
    faqId: 4,
    question: "Visa Documentation",
    answer:
      "After you book our tour,our visa oficer will guide you about the applicable visa formalities. You are requested to submit the required documnets within the time frame given by our visa officer.Some consulates may call you for personal interview.",
  },
  {
    faqId: 5,
    question: "Changes in pre-defined tour program",
    answer:
      "Kindly intimate the booking person in advance for any amendment in tour program so that the necessary arrangements can be made .Depending on the amendments needed ,additional charges would be applicable.",
  },
  {
    faqId: 6,
    question: "Cancelletion policy",
    answer:
      "In case you need to cancel the tour,you will need to inform us in writing. The cancellation charges are follows: .More than 45 days prior to the tour departure date-Booking Amount. 44-31 days prior to the tour departure date-50% of the total cost. 15-10 days prior to the tour departure date-75% of the total cost. Visa Fee & Service charges are non refundable. No refund either in part or in full will be made for any unused part of the services provided in the package.",
  },
];

const bookingFaqs = [
  {
    faqId: 7,
    question: "How many days in advance should I book?",
    answer:
      "You can book your tour as per your convenience ensuring that you have enough time to apply for the required Visas. However, the earlier you book, the better. Booking early (2 months or more before the departure date) is recommended so that there is adequate time for Visa processing.",
  },
  {
    faqId: 8,
    question: "Requirements at the time of booking",
    answer:
      "Note: Passport / document requirements may differ for certain Embassies/Consulates and are subject to change.",
  },
];

const afterBookingFaqs = [
  {
    faqId: 9,
    question:
      "When will I be informed about the reporting place other information related to my tour?",
    answer:
      "You will be given pre-departure information about 1 week prior to the departure date of your tour.",
  },
  {
    faqId: 10,
    question: "If I cancle my tour, is the tour cost refunded?",
    answer:
      "If the tour is cancelled on medical grounds, if supporting medical reports are given, then Insurance company at it’s own discretion may consider the refund (Subject to Cancellation Policy, Terms & Conditions of Mango Holidays India Pvt. Ltd.)",
  },
  {
    faqId: 11,
    question: "Do you provide leave travel certificate?",
    answer:
      "Leave Travel Certificate can be issued only if you inform us about the same at the time of booking the tour. Such requests cannot be processed if intimated later.",
  },
  {
    faqId: 12,
    question: "Can I modify my travel plan once the booking is done?",
    answer:
      "You can modify your travel plans by informing the sales staff about it. Additional charges are applicable for cancelling the old booking and making the new arrangements & these charges will be borne by you.",
  },
];

const whileTravellingFaqs = [
  {
    faqId: 13,
    question: "Will the tour be hectic?",
    answer:
      "Most of our group tours have a medium to fast pace, as we need to cover maximum sightseeing places in limited time/days.",
  },
  {
    faqId: 14,
    question: "Does the group tour involve a lot of walking?",
    answer:
      "Generally, you are required to walk while at sightseeing places, airports and parks. Tour manager will instruct you from time to time.",
  },
  {
    faqId: 15,
    question: "What type of food do you provide?",
    answer:
      "On our group tours, we provide Indian food for lunch and dinner because we understand that gratifying your taste buds is also a way to win your heart. With Mango Holidays we promise delicious, hygienic & healthy food keeping international quality standards in mind.",
  },
];

const upcoming_international_tours = [
  {
    navigationLink: "#",
    img: "/img/LuxeHolidays/Russia-with-northern-lights.jpg",
    ProductTitle: "Russia with Northern lights",
  },
  {
    navigationLink: "#",
    img: "/img/LuxeHolidays/Iceland-with-northern-lights.jpg",
    ProductTitle: "Iceland with Northern lights",
  },
  {
    navigationLink: "503/SAM4/mysteries-of-south-america",
    img: "/img/LuxeHolidays/South-American-mysteries.jpg",
    ProductTitle: "Mysteries of South America",
  },
  {
    navigationLink: "535/KM1/kenyan-migration",
    img: "/img/LuxeHolidays/Africa-with-Kenyan-Migration.webp",
    ProductTitle: "Africa with Kenyan Migration",
  },
  {
    navigationLink: "523/NL/northern-lights",
    img: "/img/LuxeHolidays/northern-Lights.webp",
    ProductTitle: "Northern Lights",
  },
  {
    navigationLink: "#",
    img: "/img/LuxeHolidays/South-africa-with-Kruger.jpg",
    ProductTitle: "South Africa with Kruger",
  },
  {
    navigationLink: "16/A1/new-zealand-Australia",
    img: "/img/LuxeHolidays/Australia-Newzealand.jpg",
    ProductTitle: "Australia New Zealand",
  },
];

const pocket_friendly_tours = [
  {
    navigationLink: "#",
    img: "/img/PocketFriendlyTours/Russia-with-northern-lights.jpg",
    ProductTitle: "Russia with Northern lights",
  },
  {
    navigationLink: "478/V2/vietnam-cambodia",
    img: "/img/PocketFriendlyTours/Vietnam-Cambodia.jpg",
    ProductTitle: "Vietnam Cambodia",
  },
  {
    navigationLink: "#",
    img: "/img/PocketFriendlyTours/South-africa-with-kruger.jpg",
    ProductTitle: "South Africa with kruger",
  },
  {
    navigationLink: "513/GE/glimpses-of-europe",
    img: "/img/PocketFriendlyTours/Glimpses-of-europe.jpg",
    ProductTitle: "Glimpses of Europe",
  },
  {
    navigationLink: "280/DX5/super-saver-dubai-vacation",
    img: "/img/PocketFriendlyTours/Dubai-Dreams.jpg",
    ProductTitle: "Dubai Dreams",
  },
  {
    navigationLink: "503/SAM4/mysteries-of-south-america",
    img: "/img/PocketFriendlyTours/South-American-mysteries.jpg",
    ProductTitle: "Mysteries of South America",
  },
];

const Home = () => {
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(1);
  const [bannerData, setBannerData] = useState([]);
  const [isBannerPaused, setIsBannerPaused] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [testimonial, setTestimonials] = useState([]);
  const [videoModal, setVideoModal] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [imagePopupVisible, setImagePopupVisible] = useState(false);
  const [loading, setLoading] = useState(true);

  const [bestSellers, setBestSellers] = useState([]);
  const navigate = useNavigate();
  const [isPlaying, setIsPlaying] = useState(false);

  const [openIndex, setOpenIndex] = useState(null);
  const contentRefs = useRef({});

  // ==========================================
  // DYNAMIC VIDEOS STATE
  // ==========================================
  const [clientVideos, setClientVideos] = useState([]);
  const [floatingVideo, setFloatingVideo] = useState({ title: "", url: "" });
  const [bottomVideo, setBottomVideo] = useState({
    title: "",
    thumbnail: "",
    url: "",
  });

  // ==========================================
  // SEARCH & FILTER STATE
  // ==========================================
  const [searchQuery, setSearchQuery] = useState("");
  const [searchCountry, setSearchCountry] = useState("All");
  const [allTours, setAllTours] = useState([]);
  const [availableCountries, setAvailableCountries] = useState([]);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  // Enquiry Form States & Ref
  const formRef = useRef();
  const [isEnquiryModalVisible, setIsEnquiryModalVisible] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [sendResult, setSendResult] = useState("");

  useEffect(() => {
    document.title = "Home | Mango Holidays";
  }, []);

  /* --------------------------
   LOAD BANNERS DYNAMICALLY
  ---------------------------*/
  useEffect(() => {
    async function fetchBanners() {
      try {
        const res = await fetch("/heroSection1.json");

        if (!res.ok) {
          throw new Error("Failed to load heroSection1.json");
        }

        const data = await res.json();

        // Use image paths directly from heroSection1.json
        setBannerData(data);
      } catch (e) {
        console.error("Error loading banners:", e);
      }
    }

    fetchBanners();
  }, []);

  /* ----------------------------------------------------
     LOAD STATIC JSON BLOGS
  -----------------------------------------------------*/
  useEffect(() => {
    const loadBlogs = async () => {
      try {
        const response = await fetch("/BlogsData.json");
        if (!response.ok) throw new Error("Failed to fetch blog data");
        const data = await response.json();
        const sorted = data.sort((a, b) => new Date(b.date) - new Date(a.date));
        setBlogs(sorted);
      } catch (error) {
        console.error("Error loading blogs:", error);
      }
    };
    loadBlogs();
  }, []);

  /* ----------------------------------------------------
     LOAD DYNAMIC VIDEOS DATA
  -----------------------------------------------------*/
  useEffect(() => {
    const fetchVideosData = async () => {
      try {
        const response = await fetch("/videosData.json");
        if (!response.ok) throw new Error("Failed to fetch videos data");
        const data = await response.json();

        if (data.clientVideos) setClientVideos(data.clientVideos);
        if (data.floatingVideo) setFloatingVideo(data.floatingVideo);
        if (data.bottomVideo) setBottomVideo(data.bottomVideo);
      } catch (error) {
        console.error("Error loading video data:", error);
      }
    };
    fetchVideosData();
  }, []);

  // ==========================================
  // FETCH ALL TOURS FROM API FOR SEARCH & BEST SELLERS
  // ==========================================
  useEffect(() => {
    async function fetchAllTours() {
      try {
        // Fetch ALL products from API to populate search pool
        const apiData = await getProductList({});

        if (!apiData?.ProductList || !Array.isArray(apiData.ProductList)) {
          setAllTours([]);
          setBestSellers([]);
          return;
        }

        const fullProductList = apiData.ProductList;

        // 1. Populate All Tours for the Search Bar
        setAllTours(fullProductList);

        // 2. Extract Unique Countries (SectorName) for the Filter Dropdown
        const uniqueCountries = [
          ...new Set(
            fullProductList.map((tour) => tour.SectorName).filter(Boolean),
          ),
        ];
        setAvailableCountries(uniqueCountries.sort());

        // 3. Extract Best Sellers (GIT & Valid Dates) for the slider
        const today = new Date();
        const bestSellingGITTours = fullProductList
          .filter(
            (item) => item.IsBestSelling === true && item.TravelType === "GIT",
          )
          .map((item) => {
            let matchedNetINRValue = null;
            if (Array.isArray(item.ProductPricingHeader)) {
              for (const header of item.ProductPricingHeader) {
                const fromParts = header.TourDateFrom?.split("/") || [];
                const toParts = header.TourDateTo?.split("/") || [];
                if (fromParts.length === 3 && toParts.length === 3) {
                  const fromDate = new Date(
                    `${fromParts[2]}-${fromParts[1]}-${fromParts[0]}`,
                  );
                  const toDate = new Date(
                    `${toParts[2]}-${toParts[1]}-${toParts[0]}`,
                  );
                  if (today >= fromDate && today <= toDate) {
                    matchedNetINRValue =
                      header?.ProductPricingDetail?.[0]?.NETINRValue ?? null;
                    break;
                  }
                }
              }
            }
            return { ...item, NETINRValue: matchedNetINRValue };
          });

        setBestSellers(bestSellingGITTours);
      } catch (err) {
        console.error("Failed to load products:", err.message);
        setAllTours([]);
        setBestSellers([]);
      } finally {
        setLoading(false);
      }
    }
    fetchAllTours();
  }, []);

  // ==========================================
  // SEARCH FILTERING LOGIC
  // ==========================================
  useEffect(() => {
    if (!searchQuery) {
      setFilteredSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    const lowerCaseQuery = searchQuery.toLowerCase();
    const filtered = allTours.filter((tour) => {
      // Safely check strings
      const title = tour.ProductTitle ? tour.ProductTitle.toLowerCase() : "";
      const country = tour.SectorName ? tour.SectorName : "";

      const matchText = title.includes(lowerCaseQuery);
      const matchCountry = searchCountry === "All" || country === searchCountry;

      return matchText && matchCountry;
    });

    setFilteredSuggestions(filtered);
    setShowSuggestions(true);
  }, [searchQuery, searchCountry, allTours]);

  // Handle clicking on a suggested tour
  const handleSearchClick = (tour) => {
    setShowSuggestions(false);
    setSearchQuery(""); // Clear search
    handleScrollToTop();

    // Construct dynamic link just like TourDetails.js expects
    const formattedTitle = tour.ProductTitle.toLowerCase().replace(/\s+/g, "-");
    navigate(
      `/tour-details/${tour.ProductID}/${tour.ProductCode}/${formattedTitle}`,
      {
        state: { productImg: tour.ProductImage },
      },
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setImagePopupVisible(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const isAnyModalOpen =
      videoModal || imagePopupVisible || isEnquiryModalVisible;
    document.body.style.overflow = isAnyModalOpen ? "hidden" : "auto";
  }, [videoModal, imagePopupVisible, isEnquiryModalVisible]);

  useEffect(() => {
    import("../../Testimonials/testimonial.md")
      .then((res) => fetch(res.default))
      .then((r) => r.text())
      .then((text) => {
        const blocks = text.split("---").filter((b) => b.trim());
        const parsed = blocks.map((block) => {
          const obj = {};
          block
            .split("\n")
            .map((line) => line.trim())
            .filter((line) => line && line.includes(":"))
            .forEach((line) => {
              const [rawKey, ...rawValueParts] = line.split(":");
              const key = rawKey.trim();
              let value = rawValueParts.join(":").trim();
              value = value.replace(/^"|"$/g, "").replace(/\r/g, "");
              if (key === "img") value = `${process.env.PUBLIC_URL}${value}`;
              obj[key] = value;
            });
          return obj;
        });
        setTestimonials(parsed);
      })
      .catch((err) => console.error("❌ Error loading testimonials:", err));
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const goToTourDetails = (navLink) => {
    handleScrollToTop();
    navigate(`/tour-details/${navLink}`);
  };

  const gotoPackagesPage = (navLink) => {
    handleScrollToTop();
    navigate(`/packages/${navLink}`);
  };

  const toggleFAQ = (index) => setOpenIndex(openIndex === index ? null : index);
  const openModal = () => {
    setVideoModal(true);
    setTimeout(() => setIsModalVisible(true), 10);
  };
  const closeModal = () => {
    setIsModalVisible(false);
    setTimeout(() => setVideoModal(false), 300);
  };
  const closeImagePopup = () => setImagePopupVisible(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSending(true);
    setSendResult("");

    const serviceId = "service_cys1qdu";
    const templateId = "template_u738we8";
    const publicKey = "hmZvaHSmtPHQTidlV";

    emailjs.sendForm(serviceId, templateId, formRef.current, publicKey).then(
      (result) => {
        setIsSending(false);
        setSendResult("success");
        setTimeout(() => {
          setIsEnquiryModalVisible(false);
          setSendResult("");
        }, 3000);
      },
      (error) => {
        setIsSending(false);
        setSendResult("error");
        console.error(error.text);
      },
    );
  };

  return (
    <>
      {/* ================= HERO BANNER SECTION ================= */}
      <section className="hero-banner-section">
        <Swiper
          modules={[Navigation, Autoplay]}
          navigation={{
            nextEl: ".swiper-button-next-custom",
            prevEl: ".swiper-button-prev-custom",
          }}
          autoplay={
            isBannerPaused
              ? false
              : {
                  delay: 5000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: false,
                }
          }
          loop={bannerData.length > 1}
          speed={800}
          slidesPerView={1}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          className="hero-swiper"
        >
          {bannerData.length === 0 ? (
            <SwiperSlide>
              <div className="banner-slide">
                <div className="img-container">
                  <img
                    src="/img/banner-placeholder.webp"
                    alt="Loading banner..."
                  />
                </div>
                <div className="banner-overlay">
                  <h1>Loading...</h1>
                  <h2>Please wait</h2>
                </div>
              </div>
            </SwiperSlide>
          ) : (
            bannerData.map((banner) => (
              <SwiperSlide key={banner.id}>
                <div className="banner-slide">
                  <div className="img-container">
                    <img src={banner.image} alt={banner.title} loading="lazy" />
                  </div>
                  <div
                    className="banner-overlay"
                    onClick={() => gotoPackagesPage(banner.navigationLink)}
                  >
                    <h1>{banner.title}</h1>
                    <h2>{banner.subtitle1}</h2>
                    <h2>{banner.subtitle2}</h2>
                  </div>
                </div>
              </SwiperSlide>
            ))
          )}
          <div
            className="swiper-button-prev-custom"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            &#10094;
          </div>
          <div
            className="swiper-button-next-custom"
            onClick={() => swiperRef.current?.slideNext()}
          >
            &#10095;
          </div>
        </Swiper>
        <div className="cloud-img-container">
          <img
            src="/img/banner-wave.webp"
            alt="Decorative wave"
            loading="lazy"
          />
        </div>
      </section>

      {/* Best selling packges section */}
      <section className="best_selling_packges">
        <div className="section-heading">
          <div className="top-heading">
            <h2>Explore</h2>
          </div>
          <h1>Best Selling Packages</h1>
          <p>
            Discover handpicked tours tailored just for you. Leave the planning
            to us, and indulge in unforgettable adventures hassle-free.
          </p>
        </div>

        <div className="best_selling_swiper">
          {loading ? (
            <div className="loader-container-home">
              <ClipLoader color="#ff5f10" loading={loading} size={100} />
              <p className="loading-text">Fetching Best Selling tours...</p>
            </div>
          ) : Array.isArray(bestSellers) && bestSellers.length > 0 ? (
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={4}
              slidesPerGroup={1}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              loop={bestSellers.length >= 4}
              speed={800}
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              pagination={{ clickable: true, el: ".custom-pagination-2" }}
              breakpoints={{
                320: { slidesPerView: 1, slidesPerGroup: 1 },
                700: { slidesPerView: 2, slidesPerGroup: 1 },
                1024: { slidesPerView: 3, slidesPerGroup: 1 },
                1200: { slidesPerView: 4, slidesPerGroup: 1 },
              }}
            >
              {bestSellers.map((slide, index) => (
                <SwiperSlide key={index}>
                  <div className="best-selling-image-container">
                    <div className="best-selling-image">
                      <img src={slide.ProductImage} alt="Banner Unavailable" />
                    </div>

                    <NavLink
                      className="hover-overlay"
                      to={`/tour-details/${slide.ProductID}/${slide.ProductCode}/${slide.ProductTitle.toLowerCase().replace(/\s+/g, "-")}`}
                      state={{ productImg: slide.ProductImage }}
                      onClick={handleScrollToTop}
                    >
                      <i className="fas fa-link fa-2x"></i>
                    </NavLink>

                    <div className="best-selling-overlay-content">
                      <h3>{slide.ProductTitle}</h3>
                      <p>
                        {slide.Days} days | {slide.Nights} nights
                      </p>
                      <div className="best-selling-price">
                        <h4>
                          {slide.LowestTwinSharingPrice
                            ? `₹ ${Number(slide.LowestTwinSharingPrice).toLocaleString("en-IN")}`
                            : slide.NETINRValue
                              ? `₹ ${Number(slide.NETINRValue).toLocaleString("en-IN")}`
                              : "Price on Request"}
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : null}
          <div className="custom-pagination-2"></div>
        </div>
      </section>

      {/* Upcoming international tours section */}
      <section className="upcoming_international_tours">
        <div className="section-heading">
          <div className="top-heading">
            <h2>Upcoming International Tours</h2>
          </div>
          <h1>Luxe Holidays</h1>
        </div>
        <div className="upcoming_international_swiper">
          <Swiper
            modules={[Pagination]}
            spaceBetween={12}
            slidesPerView={5}
            slidesPerGroup={4}
            pagination={{ clickable: true, el: ".custom-pagination-3" }}
            breakpoints={{
              320: { slidesPerView: 1, slidesPerGroup: 1 },
              700: { slidesPerView: 2, slidesPerGroup: 2 },
              1024: { slidesPerView: 3 },
              1200: { slidesPerView: 5 },
            }}
          >
            {upcoming_international_tours.map((slide, index) => (
              <SwiperSlide key={index}>
                <div className="upcomming-tour-image-container">
                  <div className="upcomming-tour-image">
                    <img src={slide.img} alt="Banner Unavailable" />
                  </div>
                  <div
                    className="hover-overlay"
                    onClick={() => goToTourDetails(slide.navigationLink)}
                  >
                    <i className="fas fa-link fa-2x"></i>
                  </div>
                  <h3>{slide.ProductTitle}</h3>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="custom-pagination-3"></div>
        </div>
        <NavLink to="/luxetours" onClick={handleScrollToTop}>
          <button className="btn-c">View All</button>
        </NavLink>
      </section>

      {/* Pocket friendly tours */}
      <section className="popular-pocket-friendly-tours">
        <div className="section-heading">
          <div className="top-heading">
            <h2>Popular</h2>
          </div>
          <h1>Our Most Popular Pocket Friendly Tours</h1>
        </div>
        <div className="popular-pocket-friendly-tours-swiper">
          <Swiper
            modules={[Pagination]}
            spaceBetween={20}
            slidesPerView={6}
            slidesPerGroup={3}
            pagination={{ clickable: true, el: ".custom-pagination-4" }}
            breakpoints={{
              300: { slidesPerView: 1, slidesPerGroup: 1 },
              400: { slidesPerView: 2 },
              640: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
              1200: { slidesPerView: 6 },
            }}
          >
            {pocket_friendly_tours.map((slide, index) => (
              <SwiperSlide key={index}>
                <div className="slide-card">
                  <div
                    className="img-container"
                    onClick={() => goToTourDetails(slide.navigationLink)}
                  >
                    <img src={slide.img} alt={slide.ProductTitle} />
                  </div>
                  <p>{slide.title || slide.ProductTitle}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="custom-pagination-4"></div>
        </div>
      </section>

      {/* Testimonials - Our Client Speaks */}
      <section className="our-client-says">
        <div className="section-heading">
          <div className="top-heading">
            <h2>Our Clients Speak</h2>
          </div>
          <h1>Our Clients Say!!!</h1>
        </div>
        <div className="our-client-says-swiper">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={3}
            slidesPerGroup={1}
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            pagination={{ clickable: true, el: ".custom-pagination-5" }}
            navigation={{ prevEl: ".prev-custom", nextEl: ".next-custom" }}
            breakpoints={{
              320: { slidesPerView: 1 },
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1200: { slidesPerView: 3 },
            }}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            onSlideChange={(swiper) => {
              const middleIndex =
                (swiper.realIndex +
                  Math.floor(swiper.params.slidesPerView / 2)) %
                testimonial.length;
              setActiveIndex(middleIndex);
            }}
          >
            {testimonial.map((slide, index) => (
              <SwiperSlide key={index}>
                <div
                  className={`testimonial-card ${index === activeIndex ? "active" : ""}`}
                >
                  <div className="content">
                    <p className="testimonial-text">{slide.text}</p>
                    <h4 className="testimonial-author">{slide.author}</h4>
                  </div>
                  <div className="testimonial-footer">
                    <div className="testimonial-image">
                      <img src={slide.img} alt={slide.author} />
                    </div>
                    <div className="testimonial-stamp">
                      <img
                        src="/img/Happy-traveller-webp-200x109.webp"
                        alt="stamp"
                      />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="swiper-navigation-wrapper">
            <div className="prev-custom">
              <i className="fa-solid fa-arrow-left"></i>
            </div>
            <div className="next-custom">
              <i className="fa-solid fa-arrow-right"></i>
            </div>
          </div>
          <div className="custom-pagination-5"></div>
        </div>
      </section>

      {/* Youtube Videos */}
      <section className="our-client-videos">
        <div className="section-heading">
          <h1>Our Clients Video</h1>
        </div>
        <div className="our-client-videos-swiper">
          {clientVideos.length > 0 ? (
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={3}
              slidesPerGroup={1}
              loop={true}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              pagination={{ clickable: true, el: ".custom-pagination-6" }}
              navigation={{
                prevEl: ".video-prev-custom",
                nextEl: ".video-next-custom",
              }}
              breakpoints={{
                320: { slidesPerView: 1 },
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1200: { slidesPerView: 3 },
              }}
              onSwiper={(swiper) => (swiperRef.current = swiper)}
            >
              {clientVideos.map((slide, index) => {
                // Ensure proper youtube embed format if they use youtu.be link
                const embedUrl = slide.video.includes("youtu.be/")
                  ? `https://www.youtube.com/embed/${slide.video.split("youtu.be/")[1]}?rel=0`
                  : slide.video;

                return (
                  <SwiperSlide key={index}>
                    <div className="video-container">
                      <iframe
                        src={embedUrl}
                        title={`YouTube video ${index}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                      <h2 className="video-author">{slide.author}</h2>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          ) : (
            <p style={{ textAlign: "center" }}>Loading videos...</p>
          )}
          <div className="swiper-navigation-wrapper-videos">
            <div className="video-prev-custom">
              <i className="fa-solid fa-arrow-left"></i>
            </div>
            <div className="video-next-custom">
              <i className="fa-solid fa-arrow-right"></i>
            </div>
          </div>
          <div className="custom-pagination-6"></div>
        </div>
      </section>

      {/* Blogs */}
      <section className="blog-section">
        <div className="section-heading">
          <div className="top-heading">
            <h2>Travel Guides</h2>
          </div>
          <h1>Our Latest Blogs</h1>
        </div>

        <div className="blog-grid">
          {blogs.length === 0 ? (
            <p className="no-blogs">Loading blogs...</p>
          ) : (
            blogs.slice(0, 3).map((blog) => (
              <div key={blog.id} className="blog-card">
                <div className="blog-image-container">
                  <div className="blog-image">
                    <img src={blog.background_image} alt={blog.title} />
                  </div>
                  <p className="blog-date">
                    <i className="fa fa-calendar-alt" /> {blog.date}
                  </p>
                </div>

                <div className="blog-content">
                  <h2>
                    <a
                      href={blog.fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {blog.title}
                    </a>
                  </h2>
                  <p>{blog.subtitle}</p>
                  <div className="button-container">
                    <a
                      href={blog.fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-c"
                      style={{
                        textDecoration: "none",
                        display: "inline-block",
                        textAlign: "center",
                      }}
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <NavLink to="/all-blogs" onClick={handleScrollToTop} className="btn">
            View All Blogs
          </NavLink>
        </div>
      </section>

      {/* Floating Elements (Now Dynamic) */}
      <section className="youtube-circle fade-in" onClick={openModal}>
        <img src="/img/videofloat.png" alt="Unavailable" />
        <h3 className="modal-video-title">
          {floatingVideo.title || "Specialities with Mango Holidays"}
        </h3>
        {videoModal && floatingVideo.url && (
          <div
            className={`modal-overlay ${isModalVisible ? "active" : "closing"}`}
            onClick={closeModal}
          >
            <div
              className="modal-youtube-video"
              onClick={(e) => e.stopPropagation()}
            >
              <span className="close" onClick={closeModal}>
                ✖
              </span>
              <div className="modal-video-container">
                <iframe
                  width="560"
                  height="315"
                  src={floatingVideo.url}
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        )}
      </section>

      {imagePopupVisible && (
        <div className="image-popup-overlay" onClick={closeImagePopup}>
          <div
            className="image-popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <span className="close-image-popup" onClick={closeImagePopup}>
              &times;
            </span>
            <div className="img-container">
              <img src="/img/popup-banner.jpeg" alt="Special Offer Popup" />
            </div>
          </div>
        </div>
      )}

      {/* Bottom Video (Now Dynamic) */}
      <section className="bottom-video-section">
        <div className="bottom-image-container">
          {isPlaying && bottomVideo.url ? (
            <iframe
              width="100%"
              height="600"
              src={bottomVideo.url}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="video-iframe"
            ></iframe>
          ) : (
            <div
              className="video-overlay-wrapper"
              onClick={() => setIsPlaying(true)}
            >
              <img
                src={bottomVideo.thumbnail || "/img/videobg2.webp"}
                alt="Video Thumbnail"
                className="video-thumbnail"
              />
              <h2 className="video-banner-title">
                {bottomVideo.title || "Why Travel With Us"}
              </h2>
              <div className="overlay-video-icon">
                <img
                  src="/img/video.png"
                  alt="Play Video"
                  className="play-icon"
                />
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-us-section">
        <div className="container">
          <h2 className="section-title">Why Choose Us?</h2>
          <div className="choose-us-grid">
            <div className="choose-us-card">
              <div className="icon-container">
                <img src="/img/values.webp" alt="Values Over Volumes" />
              </div>
              <div className="card-text">
                <h2>Values Over Volumes</h2>
                <p>
                  Unlike mass tour operators, we organize a select number of
                  exclusive tours to each destination annually, allowing us to
                  focus on quality and personalized experiences.
                </p>
              </div>
            </div>
            <div className="choose-us-card">
              <div className="icon-container">
                <img src="/img/quality.webp" alt="Quality Over Quantity" />
              </div>
              <div className="card-text">
                <h2>Quality Over Quantity</h2>
                <p>
                  We prioritize quality in every aspect of our service, from
                  selecting the finest airlines and accommodations to providing
                  premium transportation and tour experiences.
                </p>
              </div>
            </div>
            <div className="choose-us-card">
              <div className="icon-container">
                <img src="/img/team.webp" alt="Qualified Team" />
              </div>
              <div className="card-text">
                <h2>Qualified Team</h2>
                <p>
                  Our team comprises passionate and experienced individuals who
                  are dedicated to making your holidays memorable.
                </p>
              </div>
            </div>
            <div className="choose-us-card">
              <div className="icon-container">
                <img
                  src="/img/honesty.webp"
                  alt="Honest & Ethical Interactions"
                />
              </div>
              <div className="card-text">
                <h2>Honest & Ethical Interactions</h2>
                <p>
                  With Mango Holidays, you can trust that you’ll receive
                  transparent and honest dealings, with no hidden costs or
                  surprises along the way.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQs */}
      <section className="faq-section">
        <h2 className="section-title">FAQ's</h2>
        <section className="faq-container">
          {commonFaqs.map((faq) => (
            <div
              key={faq.faqId}
              className={`faq-item ${openIndex === faq.faqId ? "open" : ""}`}
              style={{
                borderBottomLeftRadius:
                  openIndex === faq.faqId ? "10px" : "0px",
                borderBottomRightRadius:
                  openIndex === faq.faqId ? "10px" : "0px",
              }}
            >
              <div className="faq-header" onClick={() => toggleFAQ(faq.faqId)}>
                <h2>{faq.question}</h2>
                <span className="icon">
                  {openIndex === faq.faqId ? (
                    <FaChevronUp />
                  ) : (
                    <FaChevronDown />
                  )}
                </span>
              </div>
              <div
                className="faq-content"
                ref={(el) => (contentRefs.current[faq.faqId] = el)}
                style={{
                  maxHeight:
                    openIndex === faq.faqId
                      ? `${contentRefs.current[faq.faqId]?.scrollHeight}px`
                      : "0px",
                  overflow: "hidden",
                  transition: "max-height 0.4s ease, padding 0.3s ease",
                }}
              >
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </section>
        <h2 className="faq-title">Booking</h2>
        <section className="faq-container">
          {bookingFaqs.map((faq) => (
            <div
              key={faq.faqId}
              className={`faq-item ${openIndex === faq.faqId ? "open" : ""}`}
              style={{
                borderBottomLeftRadius:
                  openIndex === faq.faqId ? "10px" : "0px",
                borderBottomRightRadius:
                  openIndex === faq.faqId ? "10px" : "0px",
              }}
            >
              <div className="faq-header" onClick={() => toggleFAQ(faq.faqId)}>
                <h2>{faq.question}</h2>
                <span className="icon">
                  {openIndex === faq.faqId ? (
                    <FaChevronUp />
                  ) : (
                    <FaChevronDown />
                  )}
                </span>
              </div>
              <div
                className="faq-content"
                ref={(el) => (contentRefs.current[faq.faqId] = el)}
                style={{
                  maxHeight:
                    openIndex === faq.faqId
                      ? `${contentRefs.current[faq.faqId]?.scrollHeight}px`
                      : "0px",
                  overflow: "hidden",
                  transition: "max-height 0.4s ease, padding 0.3s ease",
                }}
              >
                {faq.faqId === 8 ? (
                  <ul className="listing">
                    <li>Booking forms</li>
                    <li>
                      Passport valid for minimum 6 months from the date of
                      arrival at the destination.
                    </li>
                    <li>
                      Booking amount / Full payment depending on the time of
                      booking.
                    </li>
                    <p>
                      Note: Passport / document requirements may differ for
                      certain Embassies/Consulates and are subject to change.
                    </p>
                  </ul>
                ) : (
                  <p>{faq.answer}</p>
                )}
              </div>
            </div>
          ))}
        </section>
      </section>

      <a
        href="https://wa.me/+919225088164"
        className="floating-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <i className="fa-brands fa-whatsapp"></i>
      </a>
      <div
        className="floating-enquiry-btn"
        onClick={() => setIsEnquiryModalVisible(true)}
      >
        <i className="fa-regular fa-envelope"></i>
        <span>Quick Enquiry</span>
      </div>

      {isEnquiryModalVisible && (
        <div
          className="enquiry-modal-overlay fadeIn"
          onClick={() => setIsEnquiryModalVisible(false)}
        >
          <div
            className="enquiry-modal-content slideInUp"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="close-enquiry-btn"
              onClick={() => setIsEnquiryModalVisible(false)}
            >
              <i className="fa-solid fa-xmark"></i>
            </button>
            <h2>Plan Your Dream Trip</h2>
            <p>
              Drop your details below and our travel experts will get in touch
              with you shortly.
            </p>
            {sendResult === "success" ? (
              <div className="form-success-msg">
                <i className="fa-solid fa-circle-check"></i>
                <p>Thank you! Your enquiry has been sent successfully.</p>
              </div>
            ) : sendResult === "error" ? (
              <div className="form-error-msg">
                <i className="fa-solid fa-circle-exclamation"></i>
                <p>Oops! Something went wrong. Please try again later.</p>
              </div>
            ) : (
              <form
                ref={formRef}
                onSubmit={sendEmail}
                className="quick-enquiry-form"
              >
                <div className="form-group">
                  <input
                    type="text"
                    name="user_name"
                    placeholder="Full Name"
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    name="user_email"
                    placeholder="Email Address"
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="tel"
                    name="user_phone"
                    placeholder="Phone Number"
                    required
                  />
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    placeholder="Where would you like to travel?"
                    rows="3"
                    required
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="submit-enquiry-btn"
                  disabled={isSending}
                >
                  {isSending ? "Sending..." : "Submit Enquiry"}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
